import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import PassengerDesktopHeader from "./PassengerDesktopHeader";
import PassengerMobileHeader from "./PassengerMobileHeader";


type Props = {
  navigateHandler?: () => void
}
function PassengerHeaderNavigation({ navigateHandler }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };

  return (
      isMobile ? (
          <PassengerMobileHeader navigateHandler={handleNavigate} />
      ) : (
          <PassengerDesktopHeader navigateHandler={handleNavigate} />
      )
  )
}

PassengerHeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default PassengerHeaderNavigation;
